module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "halo-tree"
  }, [(_vm.options.showSearch) ? _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon search"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "root"
  }, [_c('i', {
    staticClass: "icon iconfont",
    class: [_vm.itemsShow ? _vm.treeNodeOptions.iconClass.open : _vm.treeNodeOptions.iconClass.close],
    style: (_vm.treeNodeOptions.iconStyle),
    on: {
      "click": _vm.rootIconClick
    }
  }), _vm._v("\n        " + _vm._s(_vm.treeNodeOptions.rootName) + "\n    ")]), _vm._v(" "), _c('vue2-tree-node', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.itemsShow),
      expression: "itemsShow"
    }],
    attrs: {
      "treeData": _vm.store.root,
      "options": _vm.treeNodeOptions
    },
    on: {
      "handlecheckedChange": _vm.handlecheckedChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab486b86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tree/tree.vue
// module id = 1075
// module chunks = 159